<div class="picker-protection">
  <div class="seg-row" role="radiogroup" aria-label="Protection type">
    @for (opt of options; track opt) {
      <button
        type="button"
        class="seg-btn"
        role="radio"
        [class.is-active]="active() === opt"
        [attr.aria-checked]="active() === opt"
        (click)="onClick(opt)"
      >{{ opt }}</button>
    }
  </div>
</div>
